import React, { useEffect, useState } from 'react';
import Turnstile  from "react-turnstile";
import { Dialog, DialogContent } from '@mui/material';
import axios from 'axios';

const TurnstileDialog = ({ open, onClose, signUp }) => {
    const [siteKey, setSiteKey] = useState(undefined);

    useEffect(() => {
        axios.get('api/Turnstile/GetPublicSiteKey').then(response => {
            setSiteKey(response.data.publicSiteKey);
        }).catch(error => {
            console.error(error);
        });
    }, []);

    return (
        <Dialog open={open && Boolean(siteKey)} onClose={onClose}>
            <DialogContent>
                <Turnstile
                    sitekey={siteKey}
                    theme="dark"
                    style={{ textAlign: "center" }}
                    onVerify={(token) => {
                        if (open) {
                            signUp(token);
                            onClose();
                        }
                    }}
                />
            </DialogContent>
        </Dialog>
    );
}

export default TurnstileDialog;
